import React, { Fragment } from 'react';

import { withStyles } from '@material-ui/styles';
import styles from './styles';
import { muiTheme } from '../../theme';

import Header from '../Header';

const Layout = ({ appSettings, user, children, classes, overflow }) => {
  return (
    <Fragment>
      <Header user={user} {...appSettings} />
      <main style={overflow ? { overflow } : {}} className={classes.pageContainer} data-testid="layout-main-container">
        {children}
      </main>
    </Fragment>
  );
};

export default withStyles(styles(muiTheme))(Layout);
